import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { CreatorLink } from '../../creator/home/components/CreatorLink';

export const LinksModal = ({
  isOpen,
  onClose,
  data,
}: {
  isOpen: boolean;
  onClose: () => void;
  data?: {
    programName: string;
    links: Array<{ title: string; url: string }>;
  };
}) => {
  if (!isOpen || !data) return null;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Share links"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <div className="flex flex-col gap-6">
        <Typography>{data.programName} Links</Typography>
        <div className="flex flex-col gap-4">
          {data.links.map((link) => (
            <CreatorLink key={link.url} {...link} />
          ))}
        </div>
        <Typography variant="body" size="large">
          When marketing your app, always refer to <b>“my app”</b> instead of
          “Playbook”, “my Playbook app” or “my Playbook.” You want people to
          sign up through your landing page or channel deep link provided above
          rather than searching for Playbook on the app store and downloading
          it.{' '}
          <b>
            You only earn revenue when subscribers sign up directly through your
            link.
          </b>
        </Typography>
      </div>
    </Modal>
  );
};
